import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
  REQUEST_ZONES,
  FETCH_ZONES_SUCCESS,
  FETCH_ZONES_FAILURE,
  SELECT_ZONE,
  RESET_CURRENT_ZONE,
  REQUEST_ZONE_DETAIL,
  FETCH_ZONE_DETAIL_SUCCESS,
  FETCH_ZONE_DETAIL_FAILURE,
  REQUEST_CREATING_ZONE,
  CREATE_ZONE_SUCCESS,
  CREATE_ZONE_FAILURE,
  REQUEST_EDITING_ZONE,
  EDIT_ZONE_SUCCESS,
  EDIT_ZONE_FAILURE,
  REQUEST_BINS,
  FETCH_BINS_SUCCESS,
  FETCH_BINS2_SUCCESS,
  FETCH_BINS3_SUCCESS,
  FETCH_BINS_FAILURE,
  RESET_BINS,
  SELECT_BIN,
  RESET_CURRENT_BIN,
  REQUEST_BIN_DETAIL,
  FETCH_BIN_DETAIL_SUCCESS,
  FETCH_BIN_DETAIL_FAILURE,
  REQUEST_CREATING_BIN,
  CREATE_BIN_SUCCESS,
  CREATE_BIN_FAILURE,
  REQUEST_EDITING_BIN,
  EDIT_BIN_SUCCESS,
  EDIT_BIN_FAILURE,
  REQUEST_DELETE_ZONE,
  DELETE_ZONE_SUCCESS,
  DELETE_ZONE_FAILURE,
  REQUEST_DELETE_BIN,
  DELETE_BIN_SUCCESS,
  DELETE_BIN_FAILURE,
  FETCH_LEVELS,
  FETCH_LEVELS_SUCCESS,
  FETCH_LEVELS2_SUCCESS,
  FETCH_LEVELS3_SUCCESS,
  FETCH_LEVELS_ERROR,
  CREATE_BARCODE,
  CREATE_BARCODE_SUCCESS,
  CREATE_BARCODE_FAILURE,
  SELECT_LEVEL, 
  REQUEST_EDITING_LEVEL,
  EDITING_LEVEL_SUCCESS,
  EDITING_LEVEL_FAILURE,
  ATTACH_ZONE_BIN_LEVEL,
  ATTACH_ZONE_BIN_LEVEL_SUCCESS,
  ATTACH_ZONE_BIN_LEVEL_FAILURE,
  CREATE_LEVEL_REQUEST,
  CREATE_LEVEL_SUCCESS,
  DELETE_LEVEL_SUCCESS,
  DELETE_LEVEL_FAILURE,
  REQUEST_DELETE_LEVEL,
  CREATE_LEVEL_FAILURE,
} from './type'

import {
  WAREHOUSES_URL,
  ZONES_URL,
  BINS_URL,
} from './url';

import {
  isUSPride,
  ROOT_URL
} from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';
// Zones Actions

export function fetchZones(Warehouse_id, defaultId) {
  const url = ZONES_URL + (Warehouse_id ? Warehouse_id : '');
  return (dispatch) => {
    dispatch({ type: REQUEST_ZONES });
    return axios.get(url,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then((response) => {
        let data = response.data || [];
        if (isUSPride && defaultId) {
          data = data.filter(item => item.warehouse_id_id === defaultId)
        }
        dispatch(fetchZonesSuccess({...response, data}));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchZonesFailure(err));
      });
  };
}

export function searchZones(name) {
  return (dispatch) => {
    dispatch({ type: REQUEST_ZONES });
    return axios.get(ZONES_URL + '?Name=' + name,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then((response) => {
        dispatch(fetchZonesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchZonesFailure(err));
      });
  };
}

export function fetchZonesSuccess(zones) {
    return {
        type: FETCH_ZONES_SUCCESS,
        payload: zones
    };
}

export function fetchZonesFailure(error) {
    return {
        type: FETCH_ZONES_FAILURE,
        payload: error
    };
}

export function selectZone(zone) {
    return {
        type: SELECT_ZONE,
        payload: zone
    };
}

export function selectLevel(zone) {
  return {
      type: SELECT_LEVEL,
      payload: zone
  };
}

export function resetCurrentZone() {
    return {
        type: RESET_CURRENT_ZONE
    }
}


export function fetchZoneDetail(zone_id) {
    return dispatch => {
        dispatch({ type: REQUEST_ZONE_DETAIL });
        return axios.get(ZONES_URL + zone_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchZoneDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchZoneDetailFailure(err));
            });
    }
}

export function fetchZoneDetailSuccess(zoneDetail) {
    return {
        type: FETCH_ZONE_DETAIL_SUCCESS,
        payload: zoneDetail
    };
}

export function fetchZoneDetailFailure(error) {
    return {
        type: FETCH_ZONE_DETAIL_FAILURE,
        payload: error
    };
}


export function createZone(
    {
        zone_num,
        description
    },
    warehouse_id) {
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_ZONE });
        axios.post(ZONES_URL,
            {
                zone_num,
                description,
                warehouse_id
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createZoneSuccess(response));
              browserHistory.push('/warehouses/detail');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createZoneFailure(err));
            });
    }
}

export function createZoneSuccess(data) {
    return {
        type: CREATE_ZONE_SUCCESS,
        payload: data
    }
}

export function createZoneFailure(error) {
    return {
        type: CREATE_ZONE_FAILURE,
        payload: error
    }
}

export function editZone({
    WarehouseZone_id,
    zone_num,
    description
}) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_ZONE });
        axios.put((ZONES_URL + WarehouseZone_id),
            {
                zone_num,
                description
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editZoneSuccess(response));
              browserHistory.push('/warehouses/detail'); // If editd succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editZoneFailure(err));
            });
    }
}

export function editZoneSuccess(data) {
    return {
        type: EDIT_ZONE_SUCCESS,
        payload: data
    }
}

export function editZoneFailure(error) {
    return {
        type: EDIT_ZONE_FAILURE,
        payload: error
    }
}

export function searchBins(name) {
    return dispatch => {
        dispatch({ type: REQUEST_BINS });
        return axios.get(BINS_URL + '?Name=' + name,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchBinsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchBinsFailure(err));
            });
    }
}

export function getBinsByZone(zoneId, idx) {
  return dispatch => {
    dispatch({type: REQUEST_BINS});
    return axios({
      method: 'GET',
      url: `${ZONES_URL}${zoneId}/section/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(response => {
      if (idx === 1) {
        dispatch(getBinsByZoneSuccess(response));
      } else if (idx === 2) {
        dispatch(getBins2ByZoneSuccess(response));
      } else if (idx === 3) {
        dispatch(getBins3ByZoneSuccess(response));
      } else {
        dispatch(getBinsByZoneSuccess(response));
      }
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(getBinsByZoneFailure(err));
    })
  }
}

export function getBinsByZoneSuccess(bins) {
  return {
    type: FETCH_BINS_SUCCESS,
    payload: bins
  };
}
export function getBins2ByZoneSuccess(bins2) {
  return {
    type: FETCH_BINS2_SUCCESS,
    payload: bins2
  };
}
export function getBins3ByZoneSuccess(bins3) {
  return {
    type: FETCH_BINS3_SUCCESS,
    payload: bins3
  };
}

export function getBinsByZoneFailure(error) {
  return {
    type: FETCH_BINS_FAILURE,
    payload: error
  };
}

export function getLevelsByBin(binId, idx) {
  return dispatch => {
    dispatch({type: FETCH_LEVELS});
    return axios({
      method: 'GET',
      url: `${WAREHOUSES_URL}section/${binId}/bin/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(response => {
      if (idx === 1) {
        dispatch(fetchLevelsSuccess(response));
      } else if (idx === 2) {
        dispatch(fetchLevels2Success(response));
      } else if (idx === 3) {
        dispatch(fetchLevels3Success(response));
      } else {
        dispatch(fetchLevelsSuccess(response));
      }
    }, err => {
      if (err.status === 500 || err.status == 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchLevelsFailure(err));
    })
  }
}

export function fetchLevelsSuccess(levels) {
  return {
      type: FETCH_LEVELS_SUCCESS,
      payload: levels
  };
}
export function fetchLevels2Success(levels2) {
  return {
      type: FETCH_LEVELS2_SUCCESS,
      payload: levels2
  };
}
export function fetchLevels3Success(levels3) {
  return {
      type: FETCH_LEVELS3_SUCCESS,
      payload: levels3
  };
}

export function fetchLevelsFailure(error) {
  return {
      type: FETCH_LEVELS_ERROR,
      payload: error
  };
}

export function fetchBins(zoneID) {
  return dispatch => {
    dispatch({ type: REQUEST_BINS });
    return axios({
      method: 'get',
      url: `${ZONES_URL}${zoneID}/bin/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(response => {
      dispatch(fetchBinsSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchBinsFailure(err));
    });
  };
}

export function generateZoneBarcode(warehouseNum, zoneId, binId, levelId) {
  let query = '';
  if (zoneId && binId && levelId) {
    query = `${warehouseNum}-${zoneId}-${binId}-${levelId}`;
  } else if (zoneId && binId && !levelId) {
    query = `${warehouseNum}-${zoneId}-${binId}`; 
  } else {
    query = `${warehouseNum}-${zoneId}`;
  }
  return dispatch => {
    dispatch({ type: CREATE_BARCODE});
    return axios({
      method: 'GET',
      url: `${WAREHOUSES_URL}printzonebinlevelbarcode/${query}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(response => {
      dispatch(generateZoneBarcodeSuccess(response))
    }, err => {
      if (err.status === 500 || err.stats == 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(generateZoneBarcodeSuccess(err));
    });
  }
}

export function generateZoneBarcodeSuccess(barcode) {
  return {
    type: CREATE_BARCODE_SUCCESS,
    payload: barcode
  }
}

export function generateZoneBarcodeFailure(error) {
  return {
    type: CREATE_BARCODE_FAILURE,
    payload: error
  }
}

export function fetchBinsSuccess(bins) {
    return {
        type: FETCH_LEVELS_SUCCESS,
        payload: bins
    };
}

export function fetchBinsFailure(error) {
    return {
        type: FETCH_BINS_FAILURE,
        payload: error
    };
}

export function resetBins() {
  return {
    type: RESET_BINS,
  };
}

export function selectBin(zone) {
    return {
        type: SELECT_BIN,
        payload: zone
    };
}

export function resetCurrentBin() {
    return {
        type: RESET_CURRENT_BIN
    }
}

export function fetchBinDetail(bin_id) {
    return dispatch => {
        dispatch({ type: REQUEST_BIN_DETAIL });
        return axios.get(BINS_URL + bin_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchBinDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchBinDetailFailure(err));
            });
    }
}

export function fetchBinDetailSuccess(binDetail) {
    return {
        type: FETCH_BIN_DETAIL_SUCCESS,
        payload: binDetail
    };
}

export function fetchBinDetailFailure(error) {
    return {
        type: FETCH_BIN_DETAIL_FAILURE,
        payload: error
    };
}

export function createBin({
    bin_num,
    description,
    section_id
}) {
    return dispatch => {
        dispatch({ type: CREATE_LEVEL_REQUEST });
       return axios.post(BINS_URL,
            {
                bin_num,
                description,
                section_id
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createLevelSuccess(response));
              // browserHistory.push('/zoneDetail');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createLevelFailure(err));
            });
    }
}

export function createBinSuccess(data) {
    return {
        type: CREATE_BIN_SUCCESS,
        payload: data
    }
}

export function createLevelSuccess(data) {
  return {
    type: CREATE_LEVEL_SUCCESS,
    payload: data
  }
}

export function createLevelFailure(err) {
  return {
    type: CREATE_LEVEL_FAILURE,
    payload: err
  }
}

export function createBinFailure(error) {
    return {
        type: CREATE_BIN_FAILURE,
        payload: error
    }
}

export function editBin({
    WarehouseBin_id,
    Name,
    description,
}) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_BIN });
        axios.put((BINS_URL + WarehouseBin_id),
            {
                Name,
                description
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editBinSuccess(response));
              // browserHistory.push('/zoneDetail'); // If edited succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editBinFailure(err));
            });
    }
}

export function editBinSuccess(data) {
    return {
        type: EDIT_BIN_SUCCESS,
        payload: data
    }
}

export function editBinFailure(error) {
    return {
        type: EDIT_BIN_FAILURE,
        payload: error
    }
}

export function deleteZone(id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_ZONE });
      axios.delete(ZONES_URL + id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
        .then(response => {
          dispatch(deleteZoneSuccess());
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(deleteZoneFailure(err));
        });
  }
}

export function deleteZoneSuccess() {
    return {
        type: DELETE_ZONE_SUCCESS,
    }
}

export function deleteZoneFailure(error) {
    return {
        type: DELETE_ZONE_FAILURE,
        payload: error
    }
}

export function deleteBin(id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_LEVEL });
      return axios.delete(BINS_URL + id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
        .then(response => {
          dispatch(deleteLevelSuccess());
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(deleteLevelFailure(err));
        });
      }
    }
export function deleteLevelSuccess() {
  return {
    type: DELETE_LEVEL_SUCCESS
  }
}

export function deleteLevelFailure(err) {
  return {
    type: DELETE_LEVEL_FAILURE,
    data: err
  }
}

export function deleteBinSuccess() {
    return {
        type: DELETE_BIN_SUCCESS,
    }
}

export function deleteBinFailure(error) {
    return {
        type: DELETE_BIN_FAILURE,
        payload: error
    }
}


export function deleteBinsBD(id) {
  return dispatch => {
    dispatch({type: REQUEST_DELETE_BIN});
    return axios.delete(`${WAREHOUSES_URL}section/${id}`,
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(deleteBinSuccess());
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(deleteBinFailure(err));
    })
  }
}

export function generateBin({
  section_num,
  description,
  zone_id
}) {
  return dispatch => {
    dispatch({type: REQUEST_CREATING_BIN});
    return axios.post(`${WAREHOUSES_URL}section/`, 
    {
      section_num,
      description, 
      zone_id
    }, 
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(createBinSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(createBinFailure(err));
    })
  }
}

export function editBins({
  section_num,
  description,
  zone_id
}, id) {
  return dispatch => {
      dispatch({ type: REQUEST_EDITING_BIN });
      axios.put((`${WAREHOUSES_URL}section/${id}`),
          {
              section_num,
              description,
              zone_id
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(editBinSuccess(response));
            // browserHistory.push('/warehouses/detail'); // If editd succesfully, refresh the paymentTerm page.
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(editBinFailure(err));
          });
  }
}

export function editLevels({
  bin_num, 
  description,
  section_id
}, id) {
  return dispatch => {
    dispatch({ type: REQUEST_EDITING_LEVEL });
      axios.put((`${WAREHOUSES_URL}bin/${id}`),
      {
        bin_num, 
        description,
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    ).then(response => {
      dispatch(editLevelSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(editLevelFailure(err));
    })
  }
}

export function editLevelSuccess(data) {
  return {
    type: EDITING_LEVEL_SUCCESS,
    payload: data
  }
}

export function editLevelFailure(err) {
  return {
    type: EDITING_LEVEL_FAILURE,
    payload: err
  }
}

export function attachZoneBinLevel(file, warehouse_id) {
  return dispatch => {
    dispatch({type: ATTACH_ZONE_BIN_LEVEL});
    const zone_bin_level_file = new FormData();
    zone_bin_level_file.append('zone_bin_level_file', file);
    zone_bin_level_file.append('warehouse_id', warehouse_id);
    return axios.post(`${ROOT_URL}v1/upload/zonebinlevel/`, zone_bin_level_file,
    {
      headers: { 
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    }
    })
    .then(response => {
      console.log("attachZoneBinLevel:", response);
      dispatch(attachZoneBinLevelSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.status = DEFAULT_ERROR
      }
      dispatch(attachZoneBinLevelFailure(err));
    })
  }
}

export function attachZoneBinLevelSuccess(data) {
  return {
    type: ATTACH_ZONE_BIN_LEVEL_SUCCESS,
  }
}

export function attachZoneBinLevelFailure(err) {
  return {
    type: ATTACH_ZONE_BIN_LEVEL_FAILURE,
    payload: err
  }
}


// WEBPACK FOOTER //
// ./master/jsx/actions/zones_actions.js